import { render, staticRenderFns } from "./ed-menu.vue?vue&type=template&id=d9421f2c&"
import script from "./ed-menu.ts?vue&type=script&lang=ts&"
export * from "./ed-menu.ts?vue&type=script&lang=ts&"
import style0 from "./ed-menu.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports